import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { DecidePmApprovalRequest, PmApprovalRequestDto } from './pm-approval.models';

@Injectable({ providedIn: 'root' })
export class PmApprovalApiService {
  private readonly api = inject(ApiService);
  private readonly base = 'v1/pm/approvals';

  list(projectId?: string, status?: number): Observable<PmApprovalRequestDto[]> {
    const params: Record<string, string | number> = {};
    if (projectId) params['projectId'] = projectId;
    if (status !== undefined && status !== null) params['status'] = status;
    return this.api.get<PmApprovalRequestDto[]>(this.base, params);
  }

  decide(id: string, body: DecidePmApprovalRequest): Observable<PmApprovalRequestDto> {
    return this.api.post<PmApprovalRequestDto>(`${this.base}/${id}/decide`, body);
  }
}
